import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex gap-2" }
const _hoisted_2 = { class: "text-2xl font-semibold text-black mb-10 select-none" }

import { ref } from "vue";
import BaseModal from "@/views/Auth/components/BaseModal.vue";
import { useI18n } from "vue-i18n";
import { AuthModalMode } from "@/types/auth";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import LoginModalContent from "@/views/Auth/components/ModalContent/LoginModalContent.vue";
import SignupModalContent from "@/views/Auth/components/ModalContent/SignupModalContent.vue";
import ForgotPasswordModalContent from "@/views/Auth/components/ModalContent/ForgotPasswordModalContent.vue";
import { useUserStore } from "@/stores/userStore";
import buddhaImage from "@/assets/buddha.webp";
import { fetchForgotPassword } from "@/api/user";
import { useToastNotificationStore } from "@/stores/toastNotificationStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthModal',
  props: {
  show: Boolean,
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {



const emits = __emit;

const { t } = useI18n();
const userStore = useUserStore();
const toastStore = useToastNotificationStore();

const modalMode = ref<AuthModalMode>("login");
const waitApiCall = ref(false);

const modalTitle = {
  login: "auth.login-title",
  signup: "auth.signup-title",
  forgot: "auth.forgot-password-title",
};

function changeModalMode(newMode: AuthModalMode) {
  modalMode.value = newMode;
}

async function handleLogin(email: string, password: string) {
  try {
    waitApiCall.value = true;
    await userStore.login(email, password);
    emits("close");
  } catch (e) {
    await toastStore.createNotificationsFromApi(e);
    console.log(e);
  } finally {
    waitApiCall.value = false;
  }
}

async function handleSignUp(
  email: string,
  password: string,
  passwordConfirm: string
) {
  try {
    waitApiCall.value = true;
    await userStore.signUp({
      email,
      password,
      password_confirmation: passwordConfirm,
    });
    emits("close");
  } catch (e) {
    await toastStore.createNotificationsFromApi(e);
    console.log(e);
  } finally {
    waitApiCall.value = false;
  }
}

async function handleForgotPassword(email: string) {
  try {
    waitApiCall.value = true;
    await fetchForgotPassword(email);
    await toastStore.createNotificationFromMessage(
      t("auth.reset-password-success")
    );
    modalMode.value = "login";
  } catch (e) {
    await toastStore.createNotificationsFromApi(e);
    console.log(e);
  } finally {
    waitApiCall.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    show: __props.show,
    "left-image-asset": _unref(buddhaImage),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (modalMode.value !== 'login')
          ? (_openBlock(), _createBlock(ArrowIcon, {
              key: 0,
              class: "text-black -rotate-[135deg] size-8 cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeModalMode('login')))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)(modalTitle[modalMode.value])), 1)
      ]),
      (modalMode.value === 'login')
        ? (_openBlock(), _createBlock(LoginModalContent, {
            key: 0,
            waitApiCall: waitApiCall.value,
            onChangeModalMode: changeModalMode,
            onLogin: handleLogin
          }, null, 8, ["waitApiCall"]))
        : (modalMode.value === 'signup')
          ? (_openBlock(), _createBlock(SignupModalContent, {
              key: 1,
              waitApiCall: waitApiCall.value,
              onSignup: handleSignUp
            }, null, 8, ["waitApiCall"]))
          : (modalMode.value === 'forgot')
            ? (_openBlock(), _createBlock(ForgotPasswordModalContent, {
                key: 2,
                waitApiCall: waitApiCall.value,
                onForgotPassword: handleForgotPassword
              }, null, 8, ["waitApiCall"]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show", "left-image-asset"]))
}
}

})